/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_TOGGLE_LARGE': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M2.5 0A2.5 2.5 0 0 0 0 2.5v19A2.5 2.5 0 0 0 2.5 24H24V0zM23 2.5V23H2.5A1.5 1.5 0 0 1 1 21.5v-19A1.5 1.5 0 0 1 2.5 1H23z"/><path pid="1" d="M6 9h12v1.5H6zm0 5h12v1.5H6z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_TOGGLE_LARGE.js